<template>
    <div class="v2-retailer-list__row">
        <router-link
            :to="`/account/lists/${list.ListID}`"
            class="v2-retailer-list__cell-title app-link"
        >
            <div class="v2-retailer-list__name">{{ list.ListName }}</div>
            <div>{{ list.items.length }} изделий</div>
        </router-link>
        <div class="v2-retailer-list__cell-imgs">
            <a
                v-for="photo of listPhotos"
                :key="photo.ItemID"
                href="javascript:void(0)"
            >
                <img :src="photo.url" class="v2-retailer-list__img ofi" />
            </a>
        </div>
        <div
            v-click-outside="hideSubmenu"
            class="v2-retailer-list__cell-btn"
            @click="toggleSubmenu"
        >
            <button
                type="button"
                class="cabinet-btn-icon cabinet-btn-icon--transparent cabinet-btn-icon--more d-block"
            ></button>
            <div
                v-if="isSubmenuOpened"
                class="app-dropdown app-dropdown--bottom app-dropdown--right"
            >
                <a
                    href="javascript:void(0)"
                    class="app-dropdown__item text-nowrap"
                    :class="{ disabled: !list.items.length }"
                    @click.prevent="addAllItemsInCart"
                >
                    В корзину
                </a>
                <a
                    href="javascript:void(0)"
                    class="app-dropdown__item text-nowrap"
                    :class="{ disabled: isDefaultList }"
                    @click.prevent="removeList"
                >
                    Удалить
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import vClickOutside from 'v-click-outside'

export default {
    name: 'ListItem',
    directives: {
        clickOutside: vClickOutside.directive
    },
    props: {
        list: {
            type: Object,
            required: true,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            isSubmenuOpened: false
        }
    },
    computed: {
        listPhotos() {
            return this.list.items.map(item => item.images[0]).slice(-5)
        },
        isDefaultList() {
            return this.list.ListName === 'Новая закупка'
        }
    },
    methods: {
        toggleSubmenu() {
            this.isSubmenuOpened = !this.isSubmenuOpened
        },
        hideSubmenu() {
            this.isSubmenuOpened = false
        },
        removeList() {
            if (this.isDefaultList) return
            this.$emit('onClickRemove', this.list)
        },
        addAllItemsInCart() {
            this.$emit('onClickAddAllItemsInCart', this.list)
        }
    }
}
</script>
